import React from 'react'

const ClosedRoles = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 12c-1.1 0-2.042-.392-2.825-1.175C6.642 10.042 6.25 9.1 6.25 8s.392-2.042 1.175-2.825C8.208 4.392 9.15 4 10.25 4s2.042.392 2.825 1.175C13.858 5.958 14.25 6.9 14.25 8s-.392 2.042-1.175 2.825C12.292 11.608 11.35 12 10.25 12Zm-7 8a.965.965 0 0 1-.712-.288A.965.965 0 0 1 2.25 19v-1.8c0-.55.142-1.067.425-1.55.283-.483.675-.85 1.175-1.1.85-.433 1.808-.8 2.875-1.1 1.067-.3 2.242-.45 3.525-.45h.35c.1 0 .2.017.3.05-.133.3-.246.613-.338.938A7.82 7.82 0 0 0 10.35 15c-.083.6-.108 1.104-.075 1.512.033.409.125.905.275 1.488.1.35.233.696.4 1.038.167.341.35.662.55.962H3.25Z"
        fill="#3249D7"
      />
      <path
        d="m16.01 18.091.53-.53-1.06-1.061 1.06-1.06-.53-.531-1.06 1.06-1.06-1.06-.531.53 1.06 1.061-1.06 1.06.53.531 1.06-1.06 1.062 1.06Zm1.592 1.06a3.65 3.65 0 0 1-1.244.826 3.784 3.784 0 0 1-1.408.275c-.477 0-.947-.092-1.409-.275a3.65 3.65 0 0 1-1.243-.825 3.65 3.65 0 0 1-.825-1.243 3.785 3.785 0 0 1-.275-1.409c0-.477.091-.947.275-1.409.183-.462.458-.876.825-1.243a3.654 3.654 0 0 1 1.243-.825 3.79 3.79 0 0 1 1.409-.275c.477 0 .947.092 1.409.275a3.65 3.65 0 0 1 1.243.825c.366.367.642.781.825 1.243.183.462.275.932.275 1.409s-.092.947-.275 1.409a3.65 3.65 0 0 1-.825 1.243Z"
        fill="#3249D7"
      />
    </svg>
  )
}

export default ClosedRoles
